import BaseResource from '@/lib/data/resource/BaseResource'

export default class FunFactsItemResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    this.Title = payload?.text ?? ''
  }

  /* PROPERTIES */

  /* METHODS */
}
